import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from 'prop-types';

import {AVAILABLE_LANGUAGES} from "../../constants/dashboard";
import {TranslatesInterface} from "../../constants/translatesInterface";

const MultiLangInput = (props) => {

  const {language, translates, onChange, onBlur, placeholder} = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const activeLanguage = language;

  const handleWrapperBlur = (e) => {
    const disallowClasses = [".multi", ".central-hub-dropdown"];
    if (!disallowClasses.some(cls => e.target.closest(cls))) {
      setDropdownVisible(false);
      setTimeout(() => onBlur(), 300)
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleWrapperBlur);
    setDropdownVisible(true);
    return () => {
      document.removeEventListener('click', handleWrapperBlur)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const styles = {
    height: dropdownVisible ? AVAILABLE_LANGUAGES.length * 50 : 0
  }

  const handleInputUpdate = (value, locale) => {
    const newTranslates = Object.assign({}, translates, {
      [locale]: value
    })
    onChange(newTranslates)
  };

  return (
    <div className="multi">
      <div className={"multi-dropdown" + (dropdownVisible ? " multi-dropdown--visible" : "")} style={styles}>
        <ul className="multi-dropdown__list ui-list">
          {AVAILABLE_LANGUAGES.map(locale => {
            return (
              <li className="multi-dropdown__list-item" key={locale}>
                <input type="text"
                       className="ui-input ui-input--dark"
                       value={translates[locale]}
                       placeholder={placeholder}
                       onChange={(event => handleInputUpdate(event.target.value, locale))}
                />
                <span className="locale">{locale}</span>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

MultiLangInput.propTypes = {
  translates: PropTypes.shape(TranslatesInterface).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string, // gray by the default, probably we would need several dropdown styles

};

const mapStateToProps = (store) => {
  return {
    language: store.dashboardState.language,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(MultiLangInput)
);
